(function () {
  'use strict';

  function initConditionPage() {
    var root = document.querySelector('#MainContent .gvfg-cond, .gvfg-cond-section-wrapper .gvfg-cond, #gvfgConditionPage');
    if (!root || root.dataset.gvfgCondInit === '1') return;
    root.dataset.gvfgCondInit = '1';
    root.classList.add('gvfg-cond--enhanced');

    var reveals = root.querySelectorAll('.gvfg-cond-reveal');
    function showReveal(el) {
      el.classList.add('is-visible');
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              showReveal(e.target);
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -20px 0px' }
      );
      reveals.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.92) showReveal(el);
        io.observe(el);
      });
    } else {
      reveals.forEach(showReveal);
    }
    setTimeout(function () {
      reveals.forEach(showReveal);
    }, 1200);

    var hero = root.querySelector('.gvfg-cond-hero');
    if (hero) {
      requestAnimationFrame(function () { hero.classList.add('is-visible'); });
    }

    root.querySelectorAll('.gvfg-cond-3d-card').forEach(function (card) {
      var inner = card.querySelector('.gvfg-cond-3d-card__inner');
      if (!inner) return;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        inner.style.transform =
          'rotateX(' + (-y * 14) + 'deg) rotateY(' + (x * 14) + 'deg) translateZ(12px)';
      });
      card.addEventListener('mouseleave', function () {
        inner.style.transform = '';
      });
    });

    var tabs = root.querySelectorAll('.gvfg-cond-quality__tab');
    var panels = root.querySelectorAll('.gvfg-cond-quality__panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-quality');
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var panel = root.querySelector('[data-quality-panel="' + id + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });

    root.querySelectorAll('.gvfg-cond-nav__pill').forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        var id = pill.getAttribute('data-section');
        var target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          root.querySelectorAll('.gvfg-cond-nav__pill').forEach(function (p) {
            p.classList.remove('is-active');
          });
          pill.classList.add('is-active');
        }
      });
    });

    root.querySelectorAll('.gvfg-cond-acc-item').forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        root.querySelectorAll('.gvfg-cond-acc-item[open]').forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });

    root.querySelectorAll('a[href^="#gvfg-cond-"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  window.gvfgInitConditionPage = function (force) {
    if (force) {
      document.querySelectorAll('.gvfg-cond').forEach(function (el) {
        delete el.dataset.gvfgCondInit;
      });
    }
    initConditionPage();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initConditionPage);
  } else {
    initConditionPage();
  }

  document.addEventListener('shopify:section:load', initConditionPage);
})();